import type { ProbeState } from "../features/health/useHealth";

const LABELS: Record<ProbeState, string> = {
  unknown: "checking",
  ok: "ready",
  failing: "unavailable",
};

/** A small readiness indicator. Colour is never the only signal. */
export function StatusPill({ state }: { state: ProbeState }) {
  return (
    <span className={`pill pill--${state}`} role="status">
      {LABELS[state]}
    </span>
  );
}
